import shared from 'servicestack/session.config.es6' //get shared


const sessionConfig = Object.assign({}, shared, {
  autoLogoutTimeout: 28800000
});

export default sessionConfig;
